exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] .jB8QTflOY2l5sEoNoP7I3{margin-top:10px}html[dir=ltr] .jB8QTflOY2l5sEoNoP7I3{margin-left:2px}html[dir=rtl] .jB8QTflOY2l5sEoNoP7I3{margin-right:2px}._1dAj-QsqUJ4F9SgN8Cm3nC{font-size:14px;font-weight:400;font-weight:300;width:500px;height:60px;overflow:auto;resize:none}html[dir] ._1dAj-QsqUJ4F9SgN8Cm3nC{padding:3px 0 0;border:0}html[dir=ltr] ._1dAj-QsqUJ4F9SgN8Cm3nC{margin-left:3px}html[dir=rtl] ._1dAj-QsqUJ4F9SgN8Cm3nC{margin-right:3px}.lQsaSx5GqPnTNlbSazwb3{font-size:14px;font-weight:400;font-weight:300}html[dir] .lQsaSx5GqPnTNlbSazwb3{margin-bottom:3px}html[dir=ltr] .lQsaSx5GqPnTNlbSazwb3{margin-left:3px}html[dir=rtl] .lQsaSx5GqPnTNlbSazwb3{margin-right:3px}.rz4RpjG2YvuhvD0ReZxAV{font-size:14px;font-weight:400;font-weight:600}", ""]);

// exports
exports.locals = {
	"settingContainer": "jB8QTflOY2l5sEoNoP7I3",
	"settingValue": "_1dAj-QsqUJ4F9SgN8Cm3nC",
	"popChoices": "lQsaSx5GqPnTNlbSazwb3",
	"settingHeader": "rz4RpjG2YvuhvD0ReZxAV"
};